function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "14 14 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h44v44H0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6.611 19.389 5 13 11.389 6.611 5 5 6.611 11.389 13 5 19.389 6.611 21 13 14.611 19.389 21 21 19.389 14.611 13Z",
    transform: "translate(9 9)",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgCancel;